// Re-export from shared id-utils for backwards compatibility
export { FESTIVAL_ID_RE } from "./id-utils";

import type { FestivalRegistryEntry } from "@/festival-data";

/**
 * Find a festival ID by matching trip destination and date range against the registry.
 * Used by GuideTab and MoreTab to detect festival trips without explicit festivalId.
 */
export function findFestivalIdForTrip(
  registry: FestivalRegistryEntry[],
  destination: string,
  startDate: string,
  endDate: string,
): string | undefined {
  const destLower = destination.toLowerCase();
  const tripStart = new Date(startDate);
  const tripEnd = new Date(endDate);
  return registry.find((entry) => {
    const locLower = entry.location.toLowerCase();
    const locationMatch = locLower.includes(destLower) || destLower.includes(locLower.split(",")[0]);
    if (!locationMatch) return false;
    return entry.dates.some((d) => {
      const festDate = new Date(d);
      return festDate >= tripStart && festDate <= tripEnd;
    });
  })?.id;
}
